/** @flow */

import {
  ToggleDisableStaffGroupModal,
  GetStaffGroups,
  GetStaffGroupsSuccess,
  GetStaffGroupsError,
  SetStaffGroupSchema,
  ToggleAddStaffGroupModal,
  ToggleReassignStaffGroupModal,
  ToggleEditStaffGroupModal,
  SetStaffGroupsSchema,
  GetStaffGroupsConfigurationSuccess,
  SetStaffGroupsSort,
  ShowReassignStaffGroupModal,
  GetTotalStaffGroups,
  GetTotalStaffGroupsSuccess,
  GetTotalStaffGroupsError,
  EditStaffGroup,
} from "@modules/service/constants/actions";
import * as staffGroupsReducers from "./reducers";
import initialState from "./state";
import type { StaffGroupsState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: StaffGroupsState = initialState, action: Object): StaffGroupsState => {
  const act = {
    [EditStaffGroup]: staffGroupsReducers.onEditStaffGroup,
    [GetStaffGroups]: staffGroupsReducers.onGetStaffGroups,
    [GetStaffGroupsSuccess]: staffGroupsReducers.onGetStaffGroupsSuccess,
    [GetStaffGroupsError]: staffGroupsReducers.onGetStaffGroupsError,
    [SetStaffGroupSchema]: staffGroupsReducers.onSetStaffGroupSchema,
    [ToggleDisableStaffGroupModal]: staffGroupsReducers.onToggleDisableStaffGroupModal,
    [ToggleReassignStaffGroupModal]: staffGroupsReducers.onToggleReassignStaffGroupModal,
    [ToggleAddStaffGroupModal]: staffGroupsReducers.onToggleAddStaffGroupModal,
    [ToggleEditStaffGroupModal]: staffGroupsReducers.onToggleEditStaffGroupModal,
    [SetStaffGroupsSchema]: staffGroupsReducers.onSetStaffGroupsSchema,
    [GetStaffGroupsConfigurationSuccess]: staffGroupsReducers.onGetStaffGroupsConfigurationSuccess,
    [SetStaffGroupsSort]: staffGroupsReducers.onSetStaffGroupsSort,
    [ShowReassignStaffGroupModal]: staffGroupsReducers.onShowReassignStaffGroupModal,
    [GetTotalStaffGroups]: staffGroupsReducers.onGetTotalStaffGroups,
    [GetTotalStaffGroupsSuccess]: staffGroupsReducers.onGetTotalStaffGroupsSuccess,
    [GetTotalStaffGroupsError]: staffGroupsReducers.onGetTotalStaffGroupsError,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
